export const fetchWithRetry = async (url: string, options?: any, retries = 3, delay = 1000): Promise<any> => {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(url, {...options});
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    } catch (error) {
      const isLastAttempt = i === retries - 1;
      if (isLastAttempt) throw error;
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
};